import React from 'react';
import { Switch } from 'react-router-dom';

// tslint:disable-next-line:no-unused-variable
import PrivateRoute from 'app/shared/auth/private-route';
import { AUTHORITIES } from 'app/config/constants';

import Tenant from './tenant';
import Domain from './domain';
import App from './app';
import Log from './log';
/* jhipster-needle-add-route-import - JHipster will add routes here */

const Routes = ({ match }) => (
  <div>
    <Switch>
      {/* prettier-ignore */}
      <PrivateRoute path={`${match.url}/tenant`} component={Tenant} hasAnyAuthorities={[AUTHORITIES.YODA]} />
      <PrivateRoute path={`${match.url}/domain`} component={Domain} hasAnyAuthorities={[AUTHORITIES.YODA]}/>
      <PrivateRoute path={`${match.url}/app`} component={App} hasAnyAuthorities={[AUTHORITIES.YODA]}/>
      <PrivateRoute path={`${match.url}/log`} component={Log} hasAnyAuthorities={[AUTHORITIES.YODA]}/>
      {/* jhipster-needle-add-route-path - JHipster will routes here */}
    </Switch>
  </div>
);

export default Routes;
